import { onMounted, watch, computed } from "vue"
import { useStore } from "vuex"
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: "TilmeldProfilKvittering",
    setup(){
        const store = useStore()
        const gtmActive = !!window?.dataLayer?.find(
            (element) => element['gtm.start']
        ) // check if gtm is active

        let first,
            last,
            close

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        onMounted(() => {
            
            first = document.querySelector(
                '.kb-button[data-order="first"]'
            )
            last = document.querySelector(
                '.kb-button[data-order="last"]'
            )
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        first.focus()
                    }
                },
                { persistent: true }
            )

            if (!gtmActive) return
            window.dataLayer = window.dataLayer || []
            dataLayer.push({ ecommerce: null })
            var event = {
                event: 'opret_sfl_profil'
            }
            dataLayer.push(event)
        })

        return {
            tabTrap,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'TilmeldProfilKvittering',
                    labelKey
                })
        }
    }
}